import { AxiosInstance } from "axios";
import { getWithAuth, putWithAuth } from "../InitializeService";

/**
 * One slot of the JSON array stored in Availability.data. This is the exact
 * shape the Availability app (availability.teampbs.com) and the PBS Live
 * availability mini app persist, so anything written here renders there.
 */
export interface AvailabilitySlotPayload {
  /** "YYYY-MM-DD HH:mm:ss" on the next occurrence of the weekday. */
  start: string;
  /** "YYYY-MM-DD HH:mm:ss" */
  end: string;
  recurring: "FREQ=WEEKLY";
  title: string;
  color: string;
  /** Only "User Defined" slots are returned by the read endpoints. */
  availabilityType: "User Defined";
}

/** An availability row (staff or client) as returned by the Enterprise API. */
export interface AvailabilityDto {
  id: number;
  userId: string | null;
  clientId: string | null;
  /** JSON-serialised AvailabilitySlotPayload[], "[]" or null. */
  data: string | null;
  userCreated: string | null;
  userUpdated: string | null;
  dateCreated: string | null;
  dateUpdated: string | null;
  status: string | null;
  userType: number | null;
  lastRequestDate: string | null;
  description: string | null;
}

/** Body of PUT clientavailability (upsert by encrypted client id). */
export interface ClientAvailabilityRequest {
  encryptedClientId: string;
  /** JSON-serialised AvailabilitySlotPayload[] */
  data: string;
  status?: string;
  userType?: number;
  description?: string;
  /** Defaults to the caller on the server. */
  userCreated?: string;
  /** Defaults to the caller on the server. */
  userUpdated?: string;
}

export interface AvailabilityUpsertResult {
  id: number;
  created: boolean;
}

/** Status the caregiver-facing app writes on client rows. */
export const CLIENT_AVAILABILITY_STATUS = "Submitted";
/** userType of every client availability row. */
export const CLIENT_AVAILABILITY_USER_TYPE = 0;

/** Returns 404 when the client has no availability row yet. */
export const getClientAvailability = (
  encryptedClientId: string,
  instance: AxiosInstance,
) =>
  getWithAuth(
    `clientavailability?id=${encodeURIComponent(encryptedClientId)}`,
    instance,
  );

/** Creates the client's availability row or replaces its slot data (201 / 200). */
export const upsertClientAvailability = (
  req: ClientAvailabilityRequest,
  instance: AxiosInstance,
) => putWithAuth("clientavailability", req, instance);
